import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <div className="container">
          Idea Creation GmbH • Walchestrasse 15 • CH-8006 Zürich • +41 44 500 54
          00 • <a href="mailto:support@e-guma.ch">support@e-guma.ch</a>
        </div>
      </footer>
    );
  }
}

export default Footer;
